import { Extension } from '@tiptap/core';

export default Extension.create({
  name: 'literalTab',
  addKeyboardShortcuts() {
    return {
      Tab: ({ editor }) => {
        editor.commands.insertContent('\u2003');
        return true;
      },
    };
  },
});
